export const gotoNext = (sliderRef) => {
  if (sliderRef.current) {
    sliderRef.current.slickNext();
  }
};

export const gotoPrev = (sliderRef) => {
  if (sliderRef.current) {
    sliderRef.current.slickPrev();
  }
};
